import { httpsCallable } from "firebase/functions";
import { isBooleanTrue, isListNotEmpty, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";
import { functions } from ".";
import CONSTANTS from "../constants";
import Activity from "../models/Activity";

export const sendFCMMessage = async (message) => {
    try {
        if (isObjectNotEmpty(message)) {
            const func = httpsCallable(functions, "sendmessage", { timeout: 6000000 });
            const res = await func({ message });

            console.log(res?.data);
            return res?.data;
        }
    } catch (error) {
        console.log(error);
    }

    return null;
};

export const sendFCMMessages = async (messages) => {
    try {
        if (isListNotEmpty(messages)) {
            const func = httpsCallable(functions, "sendmessages", { timeout: 6000000 });
            const res = await func({ messages });

            console.log(res?.data);
            return res?.data;
        }
    } catch (error) {
        console.log(error);
    }

    return null;
};

// registers this browser for push under whoever is signed in; the server takes the user from the call's auth
export const registerPushDevice = async (token) => {
    try {
        if (isStringNotEmpty(token)) {
            const func = httpsCallable(functions, "registerpushdevice", { timeout: 60000 });
            const res = await func({ token });

            return isBooleanTrue(res?.data);
        }
    } catch (error) {
        console.log(error);
    }

    return false;
};
